import { render, staticRenderFns } from "./form-change-status.vue?vue&type=template&id=462857da"
import script from "./form-change-status.vue?vue&type=script&lang=js"
export * from "./form-change-status.vue?vue&type=script&lang=js"
import style0 from "./form-change-status.vue?vue&type=style&index=0&id=462857da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports